import { Tabs, TabsList, TabsTrigger, TabsContent } from "../../components/ui/tabs";
import Holidays from "./Holidays";
import Policies from "./Policies";

export default function HolidaysPolicies() {
  return (
    <div className="space-y-4" data-testid="holidays-policies-page">
      <div>
        <div className="eyebrow">Office Admin</div>
        <h1 className="font-sans text-3xl">Holidays &amp; Policies</h1>
      </div>
      <Tabs defaultValue="holidays">
        <TabsList>
          <TabsTrigger value="holidays" data-testid="hp-tab-holidays">Holidays</TabsTrigger>
          <TabsTrigger value="policies" data-testid="hp-tab-policies">Policies</TabsTrigger>
        </TabsList>
        <TabsContent value="holidays"><Holidays/></TabsContent>
        <TabsContent value="policies"><Policies/></TabsContent>
      </Tabs>
    </div>
  );
}
